import { FC } from 'react';
import classnames from 'classnames';

import { Link } from 'dibs-elements/exports/Link';
import TwitterIcon from 'dibs-icons/exports/legacy/Twitter';
import FacebookIcon from 'dibs-icons/exports/legacy/Facebook';
import PinterestIcon from 'dibs-icons/exports/legacy/Pinterest';
import InstagramIcon from 'dibs-icons/exports/legacy/Instagram';
import { SocialMediaType } from '../messages/socialLinks';
import { trackSocial } from 'dibs-tracking';

import style from './SocialLinkRow-style.scss';

const iconMap: Record<SocialMediaType, FC> = {
    twitter: TwitterIcon,
    facebook: FacebookIcon,
    pinterest: PinterestIcon,
    instagram: InstagramIcon,
};

export type SocialLinkRowItemProps = {
    name: SocialMediaType;
    href: string;
    dataTn?: string;
    trackingLabel?: string;
};

const SocialLinkRowItem: FC<SocialLinkRowItemProps> = props => {
    const { name, href, dataTn, trackingLabel } = props;

    if (!iconMap[name]) {
        return null;
    }

    const SocialIcon = iconMap[name];

    return (
        <li className={style.listItem}>
            <span className={style.item}>
                <Link
                    ariaLabel={name}
                    className={classnames(style.link, style[name])}
                    href={href}
                    dataTn={dataTn}
                    onClick={() => {
                        trackSocial({
                            name: trackingLabel,
                            socialAction: 'fan page',
                            opt_target: href,
                            opt_pagePath: href,
                        });
                    }}
                >
                    <SocialIcon />
                </Link>
            </span>
        </li>
    );
};

export default SocialLinkRowItem;
